import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, Events } from 'ionic-angular';
import { HttpClient } from '../../../services/HttpClient';

import { ProjectPage } from './project/project';
import { AddProjectPage } from './addProject/addProject';

@Component({
  selector: 'page-projects',
  templateUrl: 'projects.html',
  providers : [HttpClient]
})
export class ProjectsPage {

	projects;
  searchQuery = '';

  modalCtrl : ModalController;
	
  httpClient : HttpClient;

  events : Events;

  	constructor(public navCtrl: NavController, public navParams: NavParams, httpClient : HttpClient,modalCtrl : ModalController, events : Events) {
  		this.modalCtrl = modalCtrl;
      this.httpClient = httpClient;
      this.events = events;
      this.events.subscribe('addProject:done',()=>{
        this.httpCallProjects('',1000);
      });
      this.events.subscribe('project:update',()=>{
        this.httpCallProjects('',1000);
      });
      this.events.subscribe('project:delete',()=>{
        this.httpCallProjects('',1000);
      });
      this.httpCallProjects('',1000);
  	}

    onSearch(){
      if(this.searchQuery.length > 0){
        this.httpCallProjects(this.searchQuery,50);
      }else{
        this.httpCallProjects(this.searchQuery,1000);
      }
    }

    httpCallProjects(name,max){
      this.httpClient.get('/projects?name='+name+'&max='+max,(error,data)=>{
        this.projects = data.json();
      });
    }

    onClickProject(project){
      this.navCtrl.push(ProjectPage,{id : project.id});
    }

    onClickAdd(){
      this.navCtrl.push(AddProjectPage);
    }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/projects/projects.ts